// extracted by mini-css-extract-plugin
export default {"page_wrapper":"Home_page_wrapper__F+wlW","keyword":"Home_keyword__VxE+c","title":"Home_title__5eO91"};